import { message, Upload } from 'antd';
import bytes from 'bytes';
import dayjs from 'dayjs';
import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import imgDelIcon from '../../static/comt_img_del.png';
import { getComtUploadParams } from './../../actions/comment';

const selectComment = createSelector(
  state => state.comment,
  comment => comment,
);

function UploadOSS(props) {
  const {
    onChange,
    value,
    listType = 'picture-card',
    multiple = false,
    accept,
    limit,
    sizeLimit,
  } = props;
  const { uploadParams } = useSelector(selectComment);
  const dispatch = useDispatch();
  const [list, setList] = useState([]);

  useEffect(() => {
    dispatch(getComtUploadParams());
  }, []);

  const handleChange = ({ file, fileList }) => {
    if (file.status === 'error') {
      message.error('上传出错！');
    }
    setList([...fileList]);
    if (onChange) {
      if (file.status === 'done') {
        value.push(
          `${uploadParams.imgPrefix}${uploadParams.dir}${file.url}${
            file.type.toLowerCase().indexOf('gif') > -1 ? '' : uploadParams.compressSuffix
          }`,
        );
        onChange([...value]);
      }
    }
  };

  const beforeUpload = async file => {
    const expire = Number(uploadParams.expire) * 1000;
    if (!expire || expire < Date.now()) {
      await dispatch(getComtUploadParams());
    }
    if (file.size > sizeLimit) {
      message.error(`超过大小限制${bytes(sizeLimit)}，请重新选择！`);
      return false;
    }

    const suffix = file.name.slice(file.name.lastIndexOf('.'));
    const filename = `${Math.random() * 10000}-${dayjs().format(
      'YYYY-MM-DD',
    )}-${Date.now()}${suffix}`;
    file.url = filename;
    return file;
  };

  const getExtraData = file => {
    const { accessKeyId, dir, policy, signature, expire } = uploadParams;
    return {
      name: file.url,
      key: `${dir}${file.url}`,
      OSSAccessKeyId: accessKeyId,
      policy: policy,
      Signature: signature,
      success_action_status: 200, // 让服务端返回200,不然，默认会返回204
      signature,
      expire: +expire,
      'x-oss-tagging': 'inUse=false',
    };
  };

  const uploadProps = {
    fileList: list,
    action: uploadParams.host,
    listType,
    onChange: handleChange,
    data: getExtraData,
    beforeUpload,
    multiple,
    accept,
    showUploadList: false,
  };

  return (
    <>
      {value &&
        value.map((el, idx) => {
          return (
            <div key={idx} className="upload-item">
              <img alt="" src={el} className="img" />
              <img
                alt=""
                src={imgDelIcon}
                className="img-del"
                onClick={() => {
                  onChange && onChange(value.filter(v => v !== el));
                }}
              />
            </div>
          );
        })}
      {value && value.length < limit && (
        <Upload {...uploadProps}>
          <i className="iconfont icon-comt_add" />
        </Upload>
      )}
    </>
  );
}

export default memo(UploadOSS);
